import { createStore } from 'redux'
import { SummaryType } from "./seomapitype";
import moment from 'moment';

const initialState = {
  logoutTimerId: null,
  spinner: false,
  sidebarShow: 'responsive',

  chartUnitSelection: SummaryType.DAY,
  chartTargetTimestamp: moment().startOf('day').unix(),
  chartLegendCollapsedChanged: false,

  cognitoUser: null, 
  loading: false,
  modal: false,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return {...state, ...rest }
    case 'clear': 
      return initialState
    default:
      return state
  }
}

const store = createStore(changeState)
export default store